export default __webpack_public_path__ + "static/media/5.5081c6ad.jpg";